<ion-content style="--background: transparent">
  <div style="width: 100%; height: 100%;">
    <div style="width: 100%; height: 100%; display: flex; align-items: flex-end; justify-content: center;">


      <div style="width: 100%; background-color: #ffffff; padding: 20px; ">
        <div class="line"
          style="display: flex; align-items: center; justify-content: center; width: 100%; margin-bottom: 10px;">
          <ion-icon style="font-size: 20px; color: #777777; margin-right: 5px; " name="arrow-up-circle-outline">
          </ion-icon>
          <h1 style="font-size: 16px; color: #777777; margin: 0  ">Notification</h1>
        </div>

        <div
          style="width: 100%; display: flex; align-items: flex-start; flex-direction: column; margin-top: 20px; margin-bottom: 20px;">
          <div style="color: #333333; font-size: 14px; font-weight: 500; margin-bottom: 10px;">
            &#8226; You are using mobile web version! Please download/use app to continue!
          </div>
        </div>

        <div class="ion-activatable ripple-parent" (click)="openUrl()"
          style="width: 100%;cursor: pointer; display: flex; justify-content: center; align-items:center; background-color: #33C9AE; padding: 10px; border-radius: 10px; margin-bottom: 25px;">
          <div style="color: #fff; font-size: 16px; font-weight: 600; text-align: center; width: 90%; ">Try our app now
          </div>
          <ion-ripple-effect></ion-ripple-effect>
        </div>

        <div (click)="close()" style="font-size: 11px; color: #777777; text-align: center; width: 100%;">
          Skip to continue
        </div>
      </div>
    </div>
  </div>
</ion-content>